const url = {
    baseURL:'https://ecoclubs.education.gov.in/api/'
}
const getBaseURL = () => {
    return url;
}

const baseUrl = getBaseURL();
export default baseUrl;

